import React from 'react'

import Layout from '../components/layout'

import './styles/training.scss';
import SEO from "../components/seo"

const training = ({data}) => {
    
    
    
    return (
        <Layout title="Pre-conference Developer Training" >
            <SEO title="Pre-conference Developer Training" />
            <div className="container" >
                <p style={{marginTop: `3.5rem`}}>Though the pre-conference training sessions have ended, GridGain periodically offers complimentary, live Apache Ignite training classes. Please click on the links below to join us at a future event.</p>
            
                <article className="training-session" >
                    <header>
                        <div className="img-wrapper"><img alt="Denis Magda pic" src={'/2021/images/training-instructors/denis-magda.jpg'} width="600" height="627"  /></div>
                        <div className="txt-wrapper">
                            <h2>Apache Ignite Essentials: Key Design Principles for Building Data-Intensive Applications</h2>
                            
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Denis Magda - <i>VP, Developer Relations in R&amp;D at GridGain; Apache Ignite committer and PMC member</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                        </div>
                    </header>

                    <p>This two-hour training is for Java developers and architects who build high-performance and data-intensive applications that are powered by Apache Ignite. During the course, you are introduced to three of Ignite's essential capabilities (data partitioning, affinity co-location, and co-located processing) and learn how to apply your newly acquired knowledge to increase the speed and scale of your applications.</p>

                    <h4>Training Topics:</h4>
                    <ul>
                        <li>The essential capabilities of Apache Ignite</li>
                        <li>How to use data partitioning to achieve limitless horizontal scalability</li>
                        <li>How affinity co-location of data makes it possible to run high-performance, distributed queries at scale</li>
                        <li>How to run custom compute tasks straight on the cluster nodes, to negate any negative impact that a network might have on the performance of your applications.</li>
                    </ul>
                    
                    <h4>Required Preparation:</h4>
                    <ul>
                        <li>Java Developer Kit 8.0 later</li>
                        <li>Apache Maven 3.0 or later</li>
                        <li>Your favorite IDE, such as IntelliJ IDEA or Eclipse, or a simple text editor</li>
                    </ul>

                    <div className="cta"><a href="https://www.gridgain.com/products/services/training/apache-ignite-essentials" target="_blank" rel="noreferrer" className="rounded-button">Learn More</a></div>
                </article>
            

                <article className="training-session" >
                    <header>
                    <div className="img-wrapper"><img alt="Greg pic" src={'/2021/images/training-instructors/greg-stachnick.jpg'} width="231" height="231"  /></div>
                        <div className="txt-wrapper">
                            <h2>How to Monitor and Manage Apache Ignite With GridGain Control Center</h2>
                            <div className="instructor">
                                <strong>Instructor:</strong> <span>Greg Stachnick - <i>Director of Product Management at GridGain</i></span>
                            </div>
                            <div className="instructor">
                                <strong>Price:</strong> <span>Free</span>
                            </div>
                        </div>
                    </header>

                    <p>This two-hour, hands-on training is for those wondering how to monitor and manage Apache Ignite clusters in production: what the most important metrics are, how to set up alerting or troubleshoot performance when the cluster is under the production load, and develop queries. The list of questions and challenges related to Ignite production monitoring goes on and on. And you’ll get many of those questions covered.</p>

                    <p>During the training, you’re going to set up a management and monitoring solution based on GridGain Control Center, an enterprise-grade tool for Ignite deployments. The solution will let you perform or automate the following tasks:</p>
                    <ul>
                        <li>Ignite storage monitoring - includes but not limited to the memory and disk usage, checkpointing, and WAL-related I/O monitoring</li>
                        <li>Alerts configuration and triggering - to ensure that you are notified when a crucial cluster event occurs</li>
                        <li>Distributed tracing usage - to detect and solve bottlenecks or hot spots in operations that span multiple cluster nodes</li>
                        <li>Query development and tips to analyze query performance statistics</li>
                    </ul>

                    <h4>Required Preparation:</h4>
                    <ul>
                        <li>Docker 19 or later, or Docker Desktop Community 2.3 or later</li>
                        <li>Docker Compose 1.25.5 or later</li>
                        <li>Java Developer Kit, version 8 or later</li>
                        <li>Apache Maven 3.0 or later</li>
                        <li>Your favorite IDE, such as IntelliJ IDEA, or Eclipse, or a simple text editor.</li>
                        <li>Clone of the following repository: https://github.com/GridGain-Demos/ignite-streaming-monitoring-demo</li>
                    </ul>

                    <div className="cta"><a href="https://www.gridgain.com/products/services/training/how-monitor-and-manage-apache-ignite-gridgain-control-center" target="_blank" rel="noreferrer" className="rounded-button">Learn More</a></div>
                </article>





            </div></Layout>
        
    )
}

export default training
